// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Element from 'element-ui'
import App from './App'
import store from './store'
import router from './router'
import XaasPlugin from './xaas-plugin'
import './styles/sass/_main.scss'
import './styles/theme-orange/index.css'
import 'element-ui/lib/theme-chalk/icon.css'
import './styles/custom.scss'
import VueI18n from 'vue-i18n'
import { translations } from './messages.js'
import langRU from 'element-ui/lib/locale/lang/ru-RU'
import langAZ from './az-AZ'
import axios from 'axios'
import VueParticles from 'vue-particles'
import Cookies from 'js-cookie'

Vue.use(VueI18n)
Vue.use(VueParticles)

/**
 * Конфигурация i18n
 */

const dateTimeFormats = {
  'ru': {
    shortDay: {
      month: 'long',
      day: 'numeric'
    },
    shortDayWithWeekday: {
      month: 'long',
      day: 'numeric',
      weekday: 'long'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric'
    }
  },
  'az': {
    shortDay: {
      month: 'long',
      day: 'numeric'
    },
    shortDayWithWeekday: {
      month: 'long',
      day: 'numeric',
      weekday: 'long'
    },
    long: {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }
  }
}

translations.ru = { ...translations.ru, ...langRU }
translations.az = { ...translations.az, ...langAZ }

const supportedLocales = ['ru', 'az']

let browserLanguage = (navigator.language || navigator.userLanguage).split('-')[0]
const defaultLanguage = supportedLocales.includes(browserLanguage) ? browserLanguage : 'ru'
const cookieLanguage = Cookies.get('language')
let language = null
if (!cookieLanguage) {
  language = defaultLanguage
} else {
  language = supportedLocales.includes(cookieLanguage) ? cookieLanguage : defaultLanguage
}
Cookies.set('language', language, { expires: 30, path: window.location.pathname })
const i18n = new VueI18n({
  locale: language,
  messages: translations,
  dateTimeFormats,
  pluralizationRules: {
    /**
     * @param choice {number} индекс выбора, переданный в $tc: `$tc('path.to.rule', choiceIndex)`
     * @param choicesLength {number} общее количество доступных вариантов
     * @returns финальный индекс для выбора соответственного варианта слова
     */
    'ru': function(choice, choicesLength) {
      // this === VueI18n экземпляра, так что свойство locale также существует здесь

      if (choice === 0) {
        return 0
      }

      const teen = choice > 10 && choice < 20
      const endsWithOne = choice % 10 === 1

      if (choicesLength < 4) {
        return (!teen && endsWithOne) ? 1 : 2
      }
      if (!teen && endsWithOne) {
        return 1
      }
      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2
      }

      return choicesLength < 4 ? 2 : 3
    }
  },
  numberFormats: {
    'ru': {
      currency: {
        style: 'currency'
      }
    }
  }
})
Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})
/**
 * Конфигурация axios
 */
axios.defaults.baseURL = process.env.VUE_APP_API_URL + 'api'
// axios.defaults.baseURL = '/api.php/api/'
axios.defaults.withCredentials = true
axios.defaults.headers['Accept'] = 'application/json'
axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response) {
    if (error.response.status === 401) {
      localStorage.setItem('auth', false)
      if (router.currentRoute.name === 'Confirm') {
        return
      } else {
        !router.currentRoute.meta.isGuest && router.push('/auth')
      }
    }
  }
  return Promise.reject(error)
})
/**
 * Использование полифила
 */
require('es6-promise').polyfill()

Vue.config.productionTip = false

Vue.use(XaasPlugin)

/**
 * Конфигурация для перехвата роутов
 */
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  if (to.meta.requiredAuth) {
    if (localStorage.getItem('auth') && localStorage.getItem('auth') !== 'false') {
      next()
    } else {
      router.push('/auth')
    }
  } else if (to.meta.isGuest) {
    if (localStorage.getItem('auth') && localStorage.getItem('auth') !== 'false') {
      router.push('/dashboard')
    } else {
      next()
    }
  } else {
    next()
  }
})
const DEFAULT_TITLE = 'Customer portal'
router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = i18n.t(to.meta.title || DEFAULT_TITLE)
  })
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
